import 'i18next';
import { Transform } from 'class-transformer';
import { IsNotEmpty, MaxLength, MinLength } from 'class-validator';

import { t } from '@app-velocity/i18n';

export const RENAME_FIGMA_REPORT_DISPLAY_NAME_MAX_LENGTH = 255;

export class RenameFigmaReportDto {
  @Transform(({ value }) =>
    typeof value === 'string' ? value.trim() : value
  )
  @IsNotEmpty({
    message: t('prototypes:validation.display_name_cannot_be_empty'),
  })
  @MinLength(1, {
    message: t('prototypes:validation.display_name_cannot_be_empty'),
  })
  @MaxLength(RENAME_FIGMA_REPORT_DISPLAY_NAME_MAX_LENGTH, {
    message: t('prototypes:validation.display_name_too_long', {
      maxLength: RENAME_FIGMA_REPORT_DISPLAY_NAME_MAX_LENGTH,
    }),
  })
  displayName = '';
}
